module.exports = __webpack_public_path__ + "img/Ajustes.ec6ce1c2.svg";